//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'helloWorld',
}



// WEBPACK FOOTER //
// ./src/page/HelloWorld.vue